import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RegularyDataComponent } from './regulary-data.component';
import { MatIconModule } from '@angular/material/icon';
import { DsrIconsModule } from '@desyre/icons-angular';
import { SharedModule } from 'src/app/shared/shared.module';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { RouterModule } from '@angular/router';

@NgModule({
    declarations: [
        RegularyDataComponent,
    ],
    exports: [
        RegularyDataComponent
    ], 
    imports: [
        CommonModule,
        SharedModule,
        DsrIconsModule,
        MatIconModule,
        TranslateModule,
        MatProgressSpinnerModule,
        RouterModule
    ], 
    providers: [provideHttpClient(withInterceptorsFromDi())]
})

export class RegularyDataModule { }